import { useSearchParams } from "react-router-dom";
import RealisticIPhone from "@/components/RealisticIPhone";
import { GALLERY } from "@/data/deviceScreens";

export default function DeviceStudio() {
  const [params] = useSearchParams();
  const app = params.get("app") || "icd10-on-the-go";
  const angle = params.get("view") === "angle";
  const raw = params.get("raw") === "1";
  const screenIdx = Math.min(parseInt(params.get("screen") || "0", 10) || 0, 2);
  const screen = (GALLERY[app] || GALLERY["icd10-on-the-go"])[screenIdx];

  if (raw) {
    return (
      <div
        data-testid="device-studio-raw"
        className="absolute left-0 top-0 overflow-hidden"
        style={{ width: 1200, height: 520 }}
      >
        {screen(true)}
      </div>
    );
  }

  return (
    <div
      data-testid="device-studio"
      className="absolute left-0 top-0 flex items-center justify-center"
      style={{ width: 800, height: 1200 }}
    >
      <RealisticIPhone angle={angle}>{screen(true)}</RealisticIPhone>
    </div>
  );
}
